import { render, staticRenderFns } from "./CertificateTreatment.vue?vue&type=template&id=c7942892&scoped=true&"
import script from "./CertificateTreatment.vue?vue&type=script&lang=ts&"
export * from "./CertificateTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateTreatment.vue?vue&type=style&index=0&id=c7942892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7942892",
  null
  
)

export default component.exports